import React from 'react';
import { Card, Typography, Tag, Space, Tooltip } from 'antd';
import { GenerateCopyResult } from '../../../types';

const { Paragraph, Text } = Typography;

interface TitleSectionProps {
    result: GenerateCopyResult;
    activeSite: string;
}

export const TitleSection: React.FC<TitleSectionProps> = ({ result, activeSite }) => {
    return (
        <Card size="small" style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                    <Space style={{ marginBottom: 8 }}>
                        <Tag color="purple">标题</Tag>
                        <Tag>{activeSite}</Tag>
                        {result.title_rationale?.[activeSite] && (
                            <Tooltip title={result.title_rationale[activeSite]}>
                                <Tag color="blue" style={{ cursor: 'help' }}>查看生成逻辑</Tag>
                            </Tooltip>
                        )}
                    </Space>
                    <Paragraph
                        style={{ fontSize: 16, fontWeight: 500, margin: 0 }}
                        copyable={{ text: result.titles[activeSite] }}
                    >
                        {result.titles[activeSite]}
                    </Paragraph>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        {result.titles[activeSite]?.length || 0} 字符
                    </Text>
                </div>
            </div>
        </Card>
    );
};
